module.exports = __webpack_public_path__ + "9b6e56aa345c770c338a7d776117ef62.jpg";